import { useQuery } from '@tanstack/react-query';
import { loginDetails } from '@/api/auth';
import { getAuthToken } from '@/api/client';

export function useLoginQuery() {
    return useQuery({
        queryKey: ['auth', 'me'],
        queryFn: loginDetails,
        enabled: Boolean(getAuthToken()),
        staleTime: Infinity,
        refetchOnMount: false,
        gcTime: 30 * 60_000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: 1,
    });
}
